import { router } from './router'

router.beforeEach((to, from, next) => {
  // 设置标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //这里判断用户是否登录，验证本地存储是否有token
    if (!localStorage.getItem('token') || localStorage.getItem('token') === '') { // 判断当前的token是否存在
      console.log(to)
      // next({
      //   path: '/login',
      //   query: { redirect: to.fullPath ,username:to.query['username'],password:to.query['password']}
      // })
      next()
    } else {
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }

  let nowtime = new Date().getTime();
  let sessiontime = nowtime - localStorage.getItem('logintime')
  if (sessiontime > 43200000 && localStorage.getItem('logintime')!=0) {
    console.log(sessiontime)
    //alert("登录超时，请重新登录")
    localStorage.setItem('token', '');
    localStorage.setItem('username', '')
    localStorage.setItem('logintime', 0)
    sessiontime = 0
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})